import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  // A autenticação usa apenas o cookie httpOnly "access_token" definido pelo backend.
  // O token NÃO é guardado no browser (localStorage/sessionStorage) para não ser
  // acessível a scripts em caso de XSS.
  withCredentials: true,
});

// Limpeza única de tokens guardados por versões anteriores da app.
try {
  if (localStorage.getItem("f2j_token")) localStorage.removeItem("f2j_token");
} catch (err) {
  // localStorage indisponível (modo privado / cookies bloqueados) — segue sem limpar
  console.warn("[api] limpeza de token legado falhou:", err?.message || err);
}

export function formatErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Ocorreu um erro. Tenta novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
